/**
 * Safari does not allow opening a pop-up not in response to a user interaction.
 * It can, however, set the location after opening.
 *
 * Cordova's InAppBrowser cannot change the location after opening, but can open a pop-up at any time.
 *
 * @param url
 * @param target
 * @param features
 */
export async function openWindow(
    url: Promise<string>,
    target?: string,
    features?: string
): Promise<WindowProxy | null> {
    if ('cordova' in global) {
        return window.open(await url, target, features)
    } else {
        const popup = window.open(undefined, target, features)
        if (popup) popup.location = await url
        return popup
    }
}
